module.exports = __webpack_public_path__ + "img/books.e6a44021.png";